import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./app/App";
import { AuthProvider } from "./features/auth/AuthContext";
import { applyTalkBrandDocument } from "./lib/brand";
import { talkAssets } from "./lib/assets";
import "./styles.css";

function registerTalkServiceWorker(): void {
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;
  void navigator.serviceWorker.register("/service-worker.js", { scope: "/" }).catch(() => {
    // A service worker is an enhancement; room admission and media never depend on it.
  });
}

const root = document.getElementById("root");

if (!root) throw new Error("Application root is missing");

applyTalkBrandDocument();

function installTalkIcons(): void {
  const oldIcons = document.head.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]');
  oldIcons.forEach((element) => element.remove());

  const favicon = document.createElement("link");
  favicon.rel = "icon";
  favicon.type = talkAssets.favicon.includes(".svg") ? "image/svg+xml" : "image/webp";
  favicon.sizes = "any";
  favicon.href = talkAssets.favicon;
  document.head.append(favicon);

  const appleTouchIcon = document.createElement("link");
  appleTouchIcon.rel = "apple-touch-icon";
  appleTouchIcon.href = talkAssets.appleTouchIcon;
  document.head.append(appleTouchIcon);
}

installTalkIcons();
registerTalkServiceWorker();

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
